import { AbortError } from '@lingoda/errors';

export const wait = (delayMs: number) => new Promise((resolve) => setTimeout(resolve, delayMs));

export const abortableWait = (delayMs: number, abortSignal: AbortSignal): Promise<void> => {
    return new Promise((resolve, reject) => {
        const onAbort = () => {
            clearTimeout(timer);
            reject(abortSignal.reason ?? new AbortError());
        };

        const timer = setTimeout(() => {
            abortSignal.removeEventListener('abort', onAbort);
            resolve();
        }, delayMs);

        abortSignal.addEventListener('abort', onAbort, { once: true });
    });
};

export const waitTillNextFrame = (): Promise<void> =>
    new Promise((resolve) => {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => resolve());
        });
    });
